import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TypesUtilsService } from '@osos/shared/legacy-core';
import { LocalizedValueModel } from '@osos/shared/types';
import {
  ActionItem,
  CloseMenuOnScrollDirective,
  TieredMenuPositionDirective,
  ValueBasedTooltipComponent,
} from '@osos/shared/utility';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { SplitButton } from 'primeng/splitbutton';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-split-button',
  templateUrl: './tiered-split-button.component.html',
  styleUrls: ['./tiered-split-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    TieredMenuModule,
    TieredMenuPositionDirective,
    CloseMenuOnScrollDirective,
    MenuModule,
    RouterLink,
    ValueBasedTooltipComponent,
  ],
})
export class TieredSplitButtonComponent
  extends SplitButton
  implements OnInit, OnChanges, OnDestroy
{
  @Input() override iconPos: 'left' | 'right';
  @Input() override expandAriaLabel: string;
  @Input() override model: ActionItem[] = [];
  @Input() buttonLink: any;
  @Input() mainAction: ActionItem;
  @Output() actionsListOpenStatusChanged: EventEmitter<boolean> =
    new EventEmitter();

  @HostBinding('class') classList = 'p-element';

  private _destroy$ = new Subject<void>();

  actionsList: MenuItem[] = [];
  mainButtonLabel: string;
  constructor(
    private typesUtilsService: TypesUtilsService,
    private translateService: TranslateService,
  ) {
    super();
  }

  // TODO we can create a wrapper for this component and  portlet-menu component and move this logic to it
  override ngOnInit(): void {
    this.prepareMainAction();
    this.prepareActionItems();
  }

  override ngOnChanges(changes: SimpleChanges): void {
    if (changes?.model) {
      this.prepareActionItems();
    }
    if (changes?.mainAction) {
      this.prepareMainAction();
    }
  }
  prepareMainAction(): void {
    if (this.mainAction) {
      this.label =
        { ...this.prepareItem(this.mainAction) }?.label || this.label;
    }
  }

  prepareActionItems(): void {
    this.actionsList = this._prepareActionsList(this.model);
  }

  private _prepareActionsList(actions: ActionItem[]): ActionItem[] {
    return actions.map((item) => {
      const itm = this.prepareItem(item);
      if (itm?.items?.length) {
        return {
          ...itm,
          items: this._prepareActionsList(itm.items as ActionItem[]),
        };
      }
      return itm;
    });
  }

  private _getLabel(localeLabel: LocalizedValueModel): string {
    return this.typesUtilsService.getLocaleString(localeLabel);
  }

  prepareItem(item: ActionItem): ActionItem {
    if ('localeLabel' in item) {
      if (typeof item.localeLabel !== 'string') {
        item.label = this._getLabel(item.localeLabel);
      } else {
        item.label = this.translateService.instant(
          (item?.localeLabel as string) ?? '',
          item.localeParams,
        );
      }
    }
    return { ...item };
  }
  onShowSelectionsList() {
    this.actionsListOpenStatusChanged.emit(true);
  }
  onHideSelectionsList() {
    this.actionsListOpenStatusChanged.emit(false);
  }
  override ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
